module.exports = __webpack_public_path__ + "static/66637d5a9f695e30848b4aa476715c97b45ffd1feb75d67f24c571dae009f4f4-95f60f4501c1bf9a739596264a0b1fbc.jpeg";